export class TypeImpl {

    protected target: HTMLInputElement;

    public setTarget(target: HTMLInputElement): void {
        this.target = target;
    }

    protected isSupportInputType = (typeInput: string) => {
        var i = document.createElement('input');
        i.setAttribute('type', typeInput);
        return i.type !== 'text';
    }

    protected triggerEvent(el: HTMLInputElement, eventName: string) {
        try {
            const e = new Event(eventName);
            el.dispatchEvent(e);
        } catch (e) {

        }
    }

}
